'use client'

import * as React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { TableRow, TableCell } from '@/components/ui/table'

interface ShippingRatesTableSkeletonProps {
	rows?: number
}

/**
 * ShippingRatesTableSkeleton component for displaying loading state
 * Returns only table rows to be inserted into existing table structure
 */
export function ShippingRatesTableSkeleton({ rows = 10 }: ShippingRatesTableSkeletonProps) {
	return (
		<SkeletonTheme baseColor="#f8fafc" highlightColor="#f1f5f9" borderRadius="0.375rem">
			<>
				{Array.from({ length: rows }, (_, index) => (
					<TableRow key={index}>
						{/* Select Checkbox */}
						<TableCell className="w-10">
							<Skeleton height={16} width={16} />
						</TableCell>

						{/* ID */}
						<TableCell className="w-32">
							<Skeleton height={20} width={100} />
						</TableCell>

						{/* Name */}
						<TableCell>
							<Skeleton height={16} width={180} />
						</TableCell>

						{/* Actions */}
						<TableCell className="w-10">
							<Skeleton height={32} width={32} borderRadius="0.25rem" />
						</TableCell>
					</TableRow>
				))}
			</>
		</SkeletonTheme>
	)
}

